import React, { Fragment } from 'react';

// import DIALOG FROM  "";

const Dialogs = () => (
    <Fragment>
        {/* <DIALOG /> */}
    </Fragment>
);

export default Dialogs;
